import React from 'react';

import { SearchOutlined } from '@ant-design/icons/lib';
import classNames from 'classnames';

import {
  TableFilterBarContainer,
  TableFilterBarFilters,
  TableFilterBarReset,
  TableFilterBarResetContainer,
  TableFilterBarSearch,
} from 'common/TableFilterBar/TableFilterBar';
import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';

import { AI_CI_CATEGORIES, PERFORMANCE_OPTIONS } from './constants';
import { CompanyTableFilters } from './types';

const CATEGORY_OPTIONS = AI_CI_CATEGORIES.map((category) => ({ label: category.label, value: category.key }));

export const EMPTY_COMPANY_TABLE_FILTERS: CompanyTableFilters = {
  performance: [],
  strongestCategories: [],
  weakestCategories: [],
};

type Props = {
  filters: CompanyTableFilters;
  onFiltersChange: (filters: CompanyTableFilters) => void;
  onSearchChange: (search: string) => void;
  categoryMode?: boolean;
};

const AICICompanyTableFilters = ({ filters, onFiltersChange, onSearchChange, categoryMode = false }: Props) => {
  const handleSelection = (fieldName: keyof CompanyTableFilters) => (selection: any[]) => {
    onFiltersChange({ ...filters, [fieldName]: selection.map((option) => option.value) });
  };

  return (
    <TableFilterBarContainer>
      <TableFilterBarFilters>
        <SelectAdvancedFilter
          placeholder="Performance"
          options={PERFORMANCE_OPTIONS}
          defaultValue={filters.performance}
          onSelect={handleSelection('performance')}
          className={classNames({ active: filters.performance.length > 0 })}
        />
        {!categoryMode && (
          <>
            <SelectAdvancedFilter
              placeholder="Strongest Category"
              options={CATEGORY_OPTIONS}
              defaultValue={filters.strongestCategories}
              onSelect={handleSelection('strongestCategories')}
              className={classNames({ active: filters.strongestCategories.length > 0 })}
            />
            <SelectAdvancedFilter
              placeholder="Weakest Category"
              options={CATEGORY_OPTIONS}
              defaultValue={filters.weakestCategories}
              onSelect={handleSelection('weakestCategories')}
              className={classNames({ active: filters.weakestCategories.length > 0 })}
            />
            <TableFilterBarResetContainer>
              <TableFilterBarReset onClick={() => onFiltersChange(EMPTY_COMPANY_TABLE_FILTERS)}>
                Reset
              </TableFilterBarReset>
            </TableFilterBarResetContainer>
          </>
        )}
      </TableFilterBarFilters>
      <TableFilterBarSearch
        prefix={<SearchOutlined />}
        placeholder="Search communities"
        onChange={(e) => onSearchChange(e?.target?.value ?? '')}
      />
    </TableFilterBarContainer>
  );
};

export default AICICompanyTableFilters;
